/* Domovoi · constants every client shares.

   The canonical origin is a constant on purpose: inside the native shell the
   page's own origin is capacitor://localhost (iOS) or https://localhost
   (Android), so share links, invite links and the analytics host must never
   be derived from window.location. */
export const ORIGIN = 'https://domovoi.ca';

/* Supabase (the Domovoi app DB) behind its custom domain. The publishable key
   is meant to be public — row-level security is what protects the data. */
export const API_URL = 'https://api.domovoi.ca';
export const PUBLISHABLE_KEY = 'sb_publishable_gcoyQzFgdG_maC7P5AjrvA_-xSRI3ka';

/* Where supabase-js keeps the session. Every page shares this one key, so a
   sign-in anywhere is a sign-in everywhere. Read it through core/session.js. */
export const AUTH_STORAGE_KEY = 'sb-selqnmjfmqzvcgwrmzrl-auth-token';

/* PostHog project token: a public, write-only key. */
/* For links into PostHog (session replays from a feedback report). */
export const POSTHOG_PROJECT = 671387;
export const POSTHOG_TOKEN = 'phc_Bp9bAYHb8EHkPTMTqKwRgnUzx3UFVA8RHSjZzKR5zKvJ';

/* Push notifications (D2.5), per platform. iPhones send straight to Apple (the
   APNs key is in the vault, read by push-send). Android waits for the Firebase
   project and google-services.json in a native build; until then the app never
   asks there, and core/push.js does nothing. */
export const PUSH_READY = { ios: true, android: true };

/* Native sign-in (D2.3). Public OAuth client IDs, not secrets: the web one is
   what Supabase's Google provider already uses (and the audience of the ID
   token), the iOS one is for the GoogleSignIn sheet on iPhones. */
export const GOOGLE_WEB_CLIENT_ID = '845343673014-d07bruqq2f5ii58c0vddakvl6gdej0fq.apps.googleusercontent.com';
export const GOOGLE_IOS_CLIENT_ID = '845343673014-cm1i9cpb2iu2v8m69gcdocln95qce17j.apps.googleusercontent.com';
